import axios from 'axios'
import authHeader from './auth-header';
import Swal from 'sweetalert2'

export default {
  async getPagina(url) {
    let ret = null;
    try {
      let consulta = await axios.get(url, {
        headers: authHeader()
      })
      let response = consulta.data;
      if (response.TodoOk == true) {
        if (response.Mensaje != "") {
          Swal.fire({
            icon: 'success',
            html: response.Mensaje
          });
        }
        ret = response.Data;
      } else {
        Swal.fire({
          icon: 'error',
          html: response.Mensaje
        });
        ret = "error"
      }
    } catch (error) {
      alert(error)
    }
    return ret;
  },
  async get(url) {
    let ret = null;
    try {
      let consulta = await axios.get(url, {
        headers: authHeader()
      })
      let response = consulta.data;
      if (response.TodoOk == true) {
        if (response.Mensaje != "") {
          Swal.fire({
            icon: 'success',
            html: response.Mensaje
          });
        }
        ret = response.Data.Datos;
      } else {
        Swal.fire({
          icon: 'error',
          html: response.Mensaje
        });
        ret = "error"
      }
    } catch (error) {
      alert(error)
    }
    return ret;
  },
  async post(url, entidad) {
    let ret = null;
    try {
      let consulta = await axios.post(url, entidad, {
        headers: authHeader()
      })
      let response = consulta.data;
      if (response.TodoOk == true) {
        if (response.Mensaje != "") {
          Swal.fire({
            icon: 'success',
            html: response.Mensaje
          });
        }
        ret = response.Data.Datos;
      } else {
        Swal.fire({
          icon: 'error',
          html: response.Mensaje
        });
        ret = "error"
      }
    } catch (error) {
      alert(error)
    }
    return ret;
  },
  async postSinToken(url, entidad) {
    let ret = null;
    try {
      let consulta = await axios.post(url, entidad)
      let response = consulta.data;
      if (response.TodoOk == true) {
        if (response.Mensaje != "") {
          Swal.fire({
            icon: 'success',
            html: response.Mensaje
          });
        }
        ret = response.Data.Datos;
      } else {
        Swal.fire({
          icon: 'error',
          html: response.Mensaje
        });
        ret = "error"
      }
    } catch (error) {
      alert(error)
    }
    return ret;
  },
  async put(url, entidad) {
    let ret = null;
    try {
      let consulta = await axios.put(url, entidad, {
        headers: authHeader()
      })
      let response = consulta.data;
      if (response.TodoOk == true) {
        if (response.Mensaje != "") {
          Swal.fire({
            icon: 'success',
            html: response.Mensaje
          });
        }
        ret = response.Data.Datos;
      } else {
        Swal.fire({
          icon: 'error',
          html: response.Mensaje
        });
        ret = "error"
      }
    } catch (error) {
      alert(error)
    }
    return ret;
  },
  async delete(url, entidad) {
    let ret = null;
    try {
      let consulta = await axios.delete(url, {
        entidad,
        headers: authHeader()
      })
      let response = consulta.data;
      if (response.TodoOk == true) {
        if (response.Mensaje != "") {
          Swal.fire({
            icon: 'success',
            html: response.Mensaje
          });
        }
        ret = response.Data.Datos;
      } else {
        Swal.fire({
          icon: 'error',
          html: response.Mensaje
        });
        ret = "error"
      }
    } catch (error) {
      alert(error)
    }
    return ret;
  },
  datetoDDMMYYYY(date) {
    if (date && date != '') {
      let d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2)
        month = '0' + month;
      if (day.length < 2)
        day = '0' + day;

      //return [year, month, day].join('-');
      return [day, month, year].join('-');
    }
  },
  datetoYYYYMMDD(date) {
    if (date && date != '') {
      let d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2)
        month = '0' + month;
      if (day.length < 2)
        day = '0' + day;

      //return [year, month, day].join('-');
      return [year, month, day].join('-');
    }
  },
  datetoDDMMYYYYHHMMSS(date) {
    let d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear(),
      hours = d.getHours(),
      mins = '' + d.getMinutes(),
      secs = '' + d.getSeconds();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    if (mins.length < 2)
      mins = '0' + mins;
    if (secs.length < 2)
      secs = '0' + secs;

    let dia = [day, month, year].join('-');
    let hora = [hours, mins, secs].join(':');
    return `${dia} ${hora}`
  },
  // recibe 'yyyy-mm-dd' y devuelve 'dd-mm-yyyy'
  dataStringToDDMMYYYY(date) {
    let ret = '';
    if (date) {
      let spl = date.split("-");
      if (spl.length === 3) {
        ret = [spl[2], spl[1], spl[0]].join('/');
      }
    }
    return ret;
  },
  getCUIT(dni, gender = 'M') {
    if (!dni || dni.length !== 8) {
      throw new Error('el dni debe tener 8 caracteres');
    }

    let genderNumber = gender === 'M' ? 20 : 27;

    const generateDigitVerificator = () => {
      const multipliers = [2, 3, 4, 5, 6, 7];
      const genderNumberAndDNI = `${genderNumber}${dni}`;

      let total = 0;
      let multipliersIndex = 0;
      for (let i = String(genderNumberAndDNI).length - 1; i > -1; i--) {
        const sum = genderNumberAndDNI[i] * multipliers[multipliersIndex];
        total += sum;
        if (multipliersIndex === 5) multipliersIndex = 0;
        else multipliersIndex += 1;
      }

      const digitVerificator = 11 - (total % 11);

      if (digitVerificator === 10) {
        genderNumber = 23;
        return generateDigitVerificator();
      }
      if (digitVerificator === 11) return 0;
      return digitVerificator;
    };

    const digitVerificator = generateDigitVerificator();

    return `${genderNumber}${dni}${digitVerificator}`;
  },
  edad(d1) {
    const d2 = new Date();
    let diff = d2.getTime() - d1.getTime();
    return Math.floor(diff / (1000 * 60 * 60 * 24 * 365.25));
  },
  dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      let aproperty = a[property] || '';
      let bproperty = b[property] || '';

      var result = (aproperty < bproperty) ? -1 : (aproperty > bproperty) ? 1 : 0;
      return result * sortOrder;
    }
  },
  validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  },
}